/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Err_BodyInputs */

const en_messages_err_body = /** @type {(inputs: Messages_Err_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a message.`)
};

const he_messages_err_body = /** @type {(inputs: Messages_Err_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כתוב הודעה.`)
};

/**
* | output |
* | --- |
* | "Write a message." |
*
* @param {Messages_Err_BodyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_err_body = /** @type {((inputs?: Messages_Err_BodyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Err_BodyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_err_body(inputs)
	return he_messages_err_body(inputs)
});